import { Separator } from '@connected/ui/components/separator';

export function InformationLineText(text: string) {
    return <p className="text-nowrap">{text}</p>;
}

export function InformationLine({
    label,
    value,
}: {
    label: React.ReactNode;
    value: React.ReactNode;
}) {
    return (

        <div className="flex items-center flex-col sm:flex-row gap-2 w-full">
            <div className="text-nowrap hidden  sm:flex font-medium text-text-secondary ">{label}</div>
            <Separator className="shrink hidden sm:flex " />
            <div className="text-nowrap hidden sm:flex  text-text-tertiary">{value}</div>
            <div className="w-full sm:hidden flex flex-col gap-1">
                <div className="text-nowrap  font-medium text-text-secondary">{label}</div>
                <div className="text-nowrap  text-text-tertiary">{value}</div>
            </div>
            <Separator className="shrink sm:hidden flex" />
        </div>
    );
}
